import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../../shared/services/auth.service';
import { AppState } from '../../store/state/app.state';
import * as EmployeeActions from '../../store/actions/employee.action';
import * as moment from 'moment';
import { FunctionsService } from '../../shared/services/functions.service';
import { HotelModel } from '../../models/hotel.model';
import * as HotelsActions from '../../store/actions/hotels.action';
import { HttpService } from '../../shared/services/http.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
export class LoginComponent implements OnInit {
  loginDetail = {
    email: '',
    password: ''
  };
  passwordFieldType: string = 'password';
  loginError;
  showError = false;
  processing = false;
  showPage = false;
  loading = true;

  constructor(
    private router: Router,
    private authService: AuthService,
    private store: Store<AppState>,
    private functions: FunctionsService,
    private httpService: HttpService,
  ) {}

  ngOnInit() {
    // this.getEmployeeAccessHotels();
    if (this.authService.loggedIn()) {
      this.checkEmployeeAuth();
    } else {
      this.loading = false;
      this.showPage = true;
    }
  }

  checkEmployeeAuth() {
    this.authService.authTest('auth/test').subscribe(
      () => {
        this.router.navigate(['/dashboard']);
      },
      () => {
        this.loading = false;
        this.authService.logOut();
        this.showPage = true;
      }
    );
  }

  loginUser() {
    this.processing = true;
    this.authService.loginUser('auth/login', this.loginDetail).subscribe(
      (res) => {
        // console.log('login user details', res);
        this.processing = false;

        // ✅ First-time login check
        // @ts-ignore
        if (res.forcePasswordChange) {
          localStorage.setItem('pendingEmail', this.loginDetail.email);
          this.router.navigate(['/change-password']);
          return;
        }

        // ✅ Store token
        localStorage.setItem('x-access-token', res.token);

        const payload = {
          token: res.token,
          ...res.data
        };
        this.store.dispatch(new EmployeeActions.loginEmployee(payload));

        const roleName = res.data.roleName?.toLowerCase();
        console.log('roleName', roleName);
        // 🧭 If Partner Admin → get their assigned hotels
        if (roleName === 'partner admin') {
          this.httpService
            .getHotels(`employees/hotels?withAccessRole=true`)
            .subscribe(
              (hotels: any[]) => {
                this.store.dispatch(new HotelsActions.getHotels(hotels));
                localStorage.setItem('access:hotels', JSON.stringify(hotels));
                console.log('Partner Hotels =>', hotels);

                if (hotels.length === 1) {
                  // ✅ If only one hotel, redirect straight to their dashboard
                  const hotel = hotels[0];
                  localStorage.setItem('current:hotel', JSON.stringify(hotel));
                  this.router.navigate(['/dashboard']);
                } else {
                  // 🏨 If multiple, show hotel selector page
                  this.router.navigate(['/partners']);
                }
              },
              (err) => {
                console.error(err);
                this.showError = true;
                this.loginError = 'Failed to fetch partner hotels.';
              }
            );
        } else {
          // 👤 Other roles → go to general partners page
          this.router.navigate(['/partners']);
        }

        // Log login activity
        this.insertLoginDetails(res.data.employeeId);
      },
      (err) => {
        this.processing = false;
        if (err instanceof HttpErrorResponse) {
          this.showError = true;
          if (err.status === 0) {
            this.loginError = 'An error occurred while connecting to server';
          } else {
            this.loginError = err.error.message;
          }
        }
      }
    );
  }


  insertLoginDetails(employeeId) {
    const momentDateTime = moment().format('YYYY-MM-DD HH:mm:SS');

    const details = {
      employeeId,
      loginDateTime: momentDateTime
    };
    this.authService
      .insertLoginDetails('employees/insertLogin', details)
      .subscribe(
        () => {},
        (err) => {
          console.log(err);
        }
      );
  }

  onDismissError() {
    this.showError = false;
  }
  togglePasswordVisibility() {
    this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
  }
  getEmployeeAccessHotels(): HotelModel[] {
    const storedHotels = localStorage.getItem('access:hotels');
    if (storedHotels) {
      return JSON.parse(storedHotels);
    } else {
      this.httpService
        .getHotels(`employees/hotels?withAccessRole=true`)
        .subscribe(
          (res) => {
            this.store.dispatch(new HotelsActions.getHotels(res));
            localStorage.setItem('access:hotels', JSON.stringify(res));
            // console.log('resresresresresres>>>>>>>>', res);
            return res;
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }
}
